import React from "react";


const ShowDifferenceTable =  ({a, b, f}) => {
  console.log(a, b, f);
  if (a && Array.isArray(a)) {
    let tot = a
      .filter(x => x.ar)
      .reduce((accum, curr) => (accum += curr[f]), 0);

    if (tot.toFixed(2) == b[f].toFixed(2)) {
      return (
        <div className="d-flex justify-content-start pe-3">
          <div>{b[f]}</div>
        </div>
      );
    } else {
      return (
        <div className="d-flex justify-content-between pe-3">
          <div className="pe-2">{b[f]} </div>

          <div className="text-danger">({tot.toFixed(2)})</div>
        </div>
      );
    }
  }
  return null;
};


export default ShowDifferenceTable